module.exports = __webpack_public_path__ + "img/ctrl-zz-1.2683a7a4.svg";